/**
 * Lightweight timeline (bottom center): rewind the last 30 minutes.
 * Scrubbing positions all aircraft from their accumulated history;
 * the LIVE button (or slider at 0) returns to live tracking.
 *
 * Note: the history is built up client-side while the app runs, so right
 * after loading only the time since page start is available.
 */
export function setupTimeline(flightManager, { historyMinutes = 30 } = {}) {
  const timeline = document.getElementById('timeline');
  const slider = document.getElementById('timeSlider');
  const liveButton = document.getElementById('liveButton');
  const label = document.getElementById('timeLabel');

  slider.min = String(-historyMinutes * 60);

  function formatOffset(offsetSeconds) {
    const m = Math.floor(offsetSeconds / 60);
    const s = offsetSeconds % 60;
    return `-${m}:${String(s).padStart(2, '0')} min`;
  }

  function apply() {
    const offsetSeconds = -parseInt(slider.value, 10);
    flightManager.setPlaybackOffset(offsetSeconds * 1000);

    const live = offsetSeconds === 0;
    timeline.classList.toggle('rewind', !live);
    liveButton.classList.toggle('is-live', live);

    if (live) {
      label.textContent = 'Jetzt';
    } else {
      const target = new Date(Date.now() - offsetSeconds * 1000);
      const clock = target.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
      label.textContent = `${formatOffset(offsetSeconds)} · ${clock}`;
    }
  }

  slider.addEventListener('input', apply);

  liveButton.addEventListener('click', () => {
    slider.value = '0';
    apply();
  });

  apply();
}
